import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NzModalRef } from 'ng-zorro-antd/modal';
import { RouteAction } from '@core/action/action';

@Component({
  selector: 'app-observacoes-modal',
  templateUrl: './observacoes-modal.component.html',
  styleUrls: ['./observacoes-modal.component.scss']
})
export class ObservacoesModalComponent implements OnInit {
  observacoesForm!: FormGroup;
  @Input() observacoes: any;
  @Input() acao!: RouteAction;
  editar = false;

  constructor(
    private fb: FormBuilder,
    private modalRef: NzModalRef,
  ) {}

  ngOnInit(): void {
    this.buildForm();
    this.editar = this.acao === RouteAction.Editar;

    if (this.observacoes && this.observacoes.textoObservacao) {
      this.observacoesForm.patchValue({ textoObservacao: this.observacoes.textoObservacao });
    }
  }

  buildForm(): void {
    this.observacoesForm = this.fb.group({
      textoObservacao: ['']
    });
  }

  salvarObservacoes(): void {
    this.modalRef.close(this.observacoesForm.getRawValue());
  }

  fecharModal(): void {
    this.modalRef.close();
  }
}
